import {useState, useEffect} from 'react';
import {Box, Card, Button, Typography, ListItem, ListItemText, ListItemButton} from '@mui/material/';
import Grid from '@mui/material/Grid2';
import { Newsletter } from '../../../types/communication/newsletter';
import { useErrorBoundary } from 'react-error-boundary';
import FeedIcon from '@mui/icons-material/Feed';

const DisplayNewsletter = (): JSX.Element => {

  const { showBoundary } = useErrorBoundary();  
  const [newsletters, setNewsletters] = useState<Newsletter[]>();
  const [selectedNewsletter, setSelectedNewsletter] = useState<Newsletter>();

  useEffect(() => {
    getNewsletterList();
  }, [])

  const getNewsletterList = async () => {

    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/newsletters/`)
      .then(result => {
        if (!result.ok) {
          showBoundary(new Error('Failed to get newsletters list.'));
        }
        return result.json();
      })
      .then(result => {
        let count = result.length;
        if (count > 0){
            setNewsletters(result.slice(0, 15));
            setSelectedNewsletter(result[0]);
        }
      });
    }catch(error){
        console.error('Uncaught Error:', error);
    }
  }


  const updateNewsletter = (newsletter: Newsletter) => () => {
    setSelectedNewsletter(newsletter);
  }

  return (
    <Box marginTop={5} marginBottom={4}>
      <Box marginBottom={4}>
        <Typography
         variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          data-aos={'fade-up'}
          fontWeight={700}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          OCPF Newsletters
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid size={{xs:12, md:9}}>
          <Box
            padding={{ xs: 3, sm: 6 }}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
             <iframe 
                title={selectedNewsletter?.title}
                aria-label={selectedNewsletter?.title +'Newsletter'}
                src={selectedNewsletter?.url} 
                width="100%" height="800px">
              </iframe>
          </Box>
        </Grid>
        <Grid size={{xs:12, md:3}}>
          <Box
            padding={2}
            width={1}
            component={Card}
            boxShadow={4}
            data-aos="fade-up"
          >
              <Box>
                <Typography fontWeight={700} variant={'subtitle1'} gutterBottom>
                  Monthly Newsletters
                </Typography>
              </Box>
              {
                  newsletters?.map((newsletter, index) =>
                    <Grid size={12} key={newsletter.id} display="flex" justifyContent={"flex-start"}>
                      <Box
                        component={ListItem}
                        disableGutters
                        width={'auto'}
                        padding={0}
                      >
                        <Box
                          aria-label='Newsletter-icon'
                          component={ListItemButton}
                          minWidth={'auto !important'}
                        >
                          <FeedIcon color="action" />
                        </Box>
                        <ListItemText primary={<Typography aria-label={newsletter.title + '-button'} title={newsletter.title} component={Button} variant='body2' onClick={updateNewsletter(newsletter)}>{newsletter.title}</Typography>} />
                      </Box>
                    </Grid>
                  )
              }
              <Box
                component={Button}
                paddingY={1 / 2}
                paddingX={1}
                borderRadius={2}
                marginTop={2}
              >
              <Button size="large" href={"/publications/newsletters"}>View All Archived Newsletters</Button>
          </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DisplayNewsletter;
